import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function AdminPrivateRoute({ children }) {
  const isloggedIn = useAuth();
  const auth = useSelector((state) => state.auth);

  return isloggedIn ? (
    auth.user.role === "admin" ? (
      // if logged in but user is an admin then show the page
      children
    ) : (
      // if logged in but user is a student then show the courseplayer page
      <Navigate to="/coursePlayer" />
    )
  ) : (
    // if not logged in then show the page admin login page
    <Navigate to="/admin/" />
  );
}
